import React, { useState, useEffect } from 'react'; // Added hooks
import { Routes, Route } from 'react-router-dom';
import Header from './Header';
import HomePage from './HomePage';
import AboutTab from './AboutTab';
import ProductsServices from './ProductServices';
import ContactTab from './ContactTab';
import ChatbotTab from './ChatbotTab';
import LoginGate from './LoginGate';         // <--- NEW: Import the Gate
import { getCurrentUser } from '../services/authService'; // <--- NEW: Import Auth Logic
import '../styles/colors';
import '../index.css';

function App() {
  // 1. State to hold the logged-in user
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 2. Check login status when the app loads
  useEffect(() => {
    async function checkLogin() {
      const loggedInUser = await getCurrentUser();
      setUser(loggedInUser);
      setIsLoading(false);
    }
    checkLogin();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* 3. Pass 'user' to Header so you can show their Avatar/Name in the top bar.
            (You will need to update Header.js slightly to accept this prop)
      */}
      <Header user={user} />

      {/* Main content area */}
      <main className="max-w-6xl mx-auto p-6">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutTab />} />
          <Route path="/products" element={<ProductsServices />} />
          <Route path="/contact" element={<ContactTab />} />

          {/* 4. THE GATED ROUTE
             If 'isLoading' -> show nothing (or a spinner)
             If 'user' exists -> Show Chat
             If 'user' is null -> Show LoginGate
          */}
          <Route
            path="/chat"
            element={
              isLoading ? <div>Loading...</div> :
              user ? <ChatbotTab user={user} /> : <LoginGate />
            }
          />
        </Routes>
      </main>

      <div className="w-full h-1 bg-gold fixed bottom-0"></div>
    </div>
  );
}

export default App;